import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDropzone } from "react-dropzone";
import {
  Form,
  Image,
  Grid,
  Table,
  Icon,
  Button,
  Comment,
  CommentGroup,
  CommentMetadata,
  GridColumn,
  GridRow,
  Segment,
  Divider,
  Header,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  List,
  Message,
  Popup,
} from "semantic-ui-react";
import { useFormik } from "formik";
import { Fuelsform, AuditLog } from "../../../../api";
const auditLogController = new AuditLog();
import { useAuth } from "../../../../hooks";
import { PERIODS } from "../../../../utils";
import {
  formatDateView,
  formatDateHourCompleted,
} from "../../../../utils/formatDate";
import { BasicModal } from "../../../Shared";
import { initialValues, validationSchema } from "./FuelsForm.form";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { decrypt, encrypt } from "../../../../utils/cryptoUtils";
import "./FuelsForm.scss";

const MAX_INVOICE_FILES = 20;
const MAX_INVOICE_FILE_SIZE = 10 * 1024 * 1024; // 10 MB, igual que el backend
import { useLanguage } from "../../../../contexts";
import { determineFuelsUnits } from "../../../../utils/dataAndFormulas/fuelsForms";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importa el CSS de react-toastify
import { invoiceCurrencySymbol, formatInvoiceAmount, formatInvoiceQuantity, INVOICE_CURRENCY_BADGE_STYLE } from "../../../../utils/invoiceFormat";
import { isAdmin, isEditor, isReviewer, isMaster } from "../../../../utils/checkPermission";
import _ from "lodash";
const fuelsFormController = new Fuelsform();

export function FuelsForm(props) {
  const {
    onClose,
    onReload,
    fuelsForm,
    site,
    siteSelected,
    year,
    period,
    configFormData,
    unitsRecorded,
  } = props;
  const { accessToken } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [listPeriods, setListPeriods] = useState([]);
  const [yearComplete, setYearComplete] = useState(false);

  const [newFiles, setNewFiles] = useState({});
  const [unitEditEnabled, setUnitEditEnabled] = useState(false);

  const PERIOD_NUM_TO_NAME = {
    "01": "January", "1": "January", "02": "February", "2": "February",
    "03": "March",   "3": "March",   "04": "April",    "4": "April",
    "05": "May",     "5": "May",     "06": "June",     "6": "June",
    "07": "July",    "7": "July",    "08": "August",   "8": "August",
    "09": "September","9": "September","10": "October", "11": "November", "12": "December",
  };

  // Lector de documentos de combustibles
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoiceResults, setInvoiceResults] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [bulkSaveLoading, setBulkSaveLoading] = useState(false);
  const [bulkSaveResults, setBulkSaveResults] = useState(null);
  const [appliedIndexes, setAppliedIndexes] = useState(new Set());
  const invoiceInputRef = useRef(null);
  const bulkSaveResultsRef = useRef(null);

  const { user } = useAuth();

  // Verificar si el usuario puede editar unidades (admin o master)
  const canEditUnits = isAdmin(user.role) || isMaster(user.role);

  const location = useLocation();
  // const { siteSelected } = location.state || {};

  const { translations, language } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  if (!siteSelected) {
    // // Manejo de caso donde no hay datos en state (por ejemplo, acceso directo a la URL)
    // return <div>No se encontraron detalles de producto.</div>;
  }

  const navigate = useNavigate();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateSite = (data, name) => {
    setFieldName(name);
    setTitleModal(`${t("comments")} ${data}`);
    onOpenCloseModal();
  };

  function setNestedError(obj, path, value) {
    const keys = path.split("."); // ["natural_gas", "unit"]
    let current = obj;
    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        current[key] = value; // asigna el mensaje de error al último nivel
      } else {
        if (!current[key]) current[key] = {}; // crea objeto si no existe
        current = current[key]; // baja al siguiente nivel
      }
    });
  }


  // Helper function to get approval status styling
  const getApprovalStatusStyle = (approvalStatus, isDisabled = false) => ({
    backgroundColor:
      approvalStatus === "approved" ? "#d4edda" :
      approvalStatus === "rejected" ? "#f8d7da" :
      approvalStatus === "pending" ? "#fff3cd" : "white",
    color:
      approvalStatus === "approved" ? "#155724" :
      approvalStatus === "rejected" ? "#721c24" :
      approvalStatus === "pending" ? "#856404" : "black",
    fontWeight: "bold",
    opacity: isDisabled ? 0.9 : 1
  });

  // Helper function para limpiar el valor 0 cuando se hace focus en el campo
  const handleFocusNumberInput = (e) => {
    const value = e.target.value;
    if (value === "0" || value === 0) {
      e.target.value = "";
    }
  };

  const formik = useFormik({
    initialValues: initialValues(fuelsForm, period, year, unitsRecorded),
    // validationSchema: validationSchema(),

    validate: (values) => {
      const errors = {};
      try {
        validationSchema().validateSync(values, { abortEarly: false });
      } catch (err) {
        if (err.inner && err.inner.length > 0) {
          err.inner.forEach((e) => {
            errors[e.path] = e.message;
            setNestedError(errors, e.path, e.message);
            formik.setFieldTouched(e.path, true, false);
          });

          // 🔹 Mostrar toast resumido
          const fields = err.inner
            .map((e) => {
              if (e.path.includes(".unit"))
                return `${t("unit")} (${t(e.path.split(".")[0])})`;
              if (e.path.includes(".value"))
                return `${t("value")} (${t(e.path.split(".")[0])})`;
              return t(e.path);
            })
            .join(", ");
          toast.error(`Faltan completar datos: ${t(fields)}`);

          // 🔹 Scroll automático al primer error
          // 🔹 Scroll automático al primer error
          const firstErrorPath = err.inner[0]?.path;
          if (firstErrorPath) {
            const fieldId = firstErrorPath.replace(/\./g, "_");
            let fieldEl =
              document.getElementById(fieldId) ||
              document.querySelector(`[name="${firstErrorPath}"]`);

            if (!fieldEl) {
              fieldEl = Array.from(
                document.querySelectorAll("input, select, textarea")
              ).find(
                (el) =>
                  el.name?.includes(firstErrorPath) || el.id?.includes(fieldId)
              );
            }

            if (fieldEl) {
              // Buscar el contenedor con scroll
              let scrollContainer = fieldEl.parentElement;
              while (
                scrollContainer &&
                scrollContainer !== document.body &&
                scrollContainer.scrollHeight <= scrollContainer.clientHeight
              ) {
                scrollContainer = scrollContainer.parentElement;
              }

              // Calcular posición
              const rect = fieldEl.getBoundingClientRect();
              const offset = 150;

              if (scrollContainer && scrollContainer !== document.body) {
                const containerRect = scrollContainer.getBoundingClientRect();
                const scrollTopTarget =
                  scrollContainer.scrollTop +
                  (rect.top - containerRect.top) -
                  offset;
                scrollContainer.scrollTo({
                  top: scrollTopTarget,
                  behavior: "smooth",
                });
              } else {
                window.scrollTo({
                  top: rect.top + window.scrollY - offset,
                  behavior: "smooth",
                });
              }

              fieldEl.focus({ preventScroll: true });
            } else {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }
        }
      }
      return errors;
    },

    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        // si hay errores, no continúa
        const errors = await formik.validateForm(formValue);
        if (Object.keys(errors).length > 0) return;

        // Upload new files first
        const fieldsWithFiles = Object.keys(newFiles).filter(field => newFiles[field] && newFiles[field].length > 0);
        for (const field of fieldsWithFiles) {
          const formData = new FormData();
          newFiles[field].forEach(file => {
            formData.append('files', file);
          });

          try {
            const uploadResponse = await fuelsFormController.uploadFileApi(accessToken, formData);
            if (uploadResponse.code === 200) {
              // Add uploaded files to formValue
              if (!formValue[field].files) {
                formValue[field].files = [];
              }
              formValue[field].files = [...formValue[field].files, ...uploadResponse.files];
            } else {
              toast.error(`Error al subir archivos para ${field}`);
              return;
            }
          } catch (uploadError) {
            console.error(`Error uploading files for ${field}:`, uploadError);
            toast.error(`Error al subir archivos para ${field}`);
            return;
          }
        }

        if (!fuelsForm) {
          formValue.creator_user = user._id;
          formValue.date = new Date();
          formValue.site = user?.site || siteSelected;

          const response = await fuelsFormController.createFuelsForm(
            accessToken,
            formValue
          );
          if (response.code === 200)
            toast.success("Formulario guardado correctamente!");
        } else {
          // Detectar cambios de unidad para auditoría (solo admin/master)
          if (isAdmin(user.role) || isMaster(user.role)) {
            const unitChanges = [];
            for (const fieldName in formValue) {
              if (formValue[fieldName]?.unit !== undefined && fuelsForm[fieldName]?.unit !== undefined) {
                if (formValue[fieldName].unit !== fuelsForm[fieldName].unit) {
                  unitChanges.push({
                    field: fieldName,
                    oldUnit: fuelsForm[fieldName].unit,
                    newUnit: formValue[fieldName].unit,
                    oldValue: fuelsForm[fieldName].value,
                    newValue: formValue[fieldName].value,
                  });
                }
              }
            }

            // Registrar cambios de unidad en auditoría
            for (const change of unitChanges) {
              try {
                await auditLogController.createAuditLog(accessToken, {
                  documentId: fuelsForm._id,
                  documentType: "fuel",
                  field: change.field,
                  oldValue: { value: change.oldValue, unit: change.oldUnit },
                  newValue: { value: change.newValue, unit: change.newUnit },
                  changeType: "unit_change",
                  changedBy: user._id,
                  site: fuelsForm.site?._id || fuelsForm.site,
                  company: fuelsForm.company,
                  year: fuelsForm.year,
                  period: fuelsForm.period,
                });
              } catch (auditError) {
                console.error("Error registrando auditoría:", auditError);
              }
            }

            if (unitChanges.length > 0) {
              toast.info(`${unitChanges.length} cambio(s) de unidad registrado(s) en auditoría`);
            }
          }

          const response2 = await fuelsFormController.updateFuelsForm(
            accessToken,
            fuelsForm._id,
            formValue
          );
          if (response2.code === 200)
            toast.success("Formulario guardado correctamente!");
        }

        // Clear newFiles after successful submission
        setNewFiles({});

        // Esperar antes de cerrar
        setTimeout(() => {
          onReload();
          if (onClose) onClose();
          else goBack();
        }, 1000);
      } catch (error) {
        console.error(error);
      }
    },
  });

  const goBack = () => {
    navigate(`/admin/data/fuelsforms`, {
      state: { siteSelected: siteSelected },
    });
  };

  const processInvoiceFiles = async (files) => {
    if (!files || files.length === 0) return;
    if (files.length > MAX_INVOICE_FILES) {
      toast.error(t("too_many_invoice_files") || `Se permiten hasta ${MAX_INVOICE_FILES} archivos por carga`);
      return;
    }
    const oversized = files.find((f) => f.size > MAX_INVOICE_FILE_SIZE);
    if (oversized) {
      toast.error(`"${oversized.name}" ${t("file_exceeds_max_size") || "supera el tamaño máximo permitido (10MB)"}`);
      return;
    }
    setInvoiceLoading(true);
    try {
      const formData = new FormData();
      files.forEach(f => formData.append("files", f));
      const result = await fuelsFormController.readDocument(accessToken, formData);
      if (result.code === 200) {
        // La lectura automática no está disponible en este momento (servicio
        // externo) y el regex tampoco pudo leer nada: no abrimos el preview.
        if (result.aiUnavailable) {
          toast.info(t("invoice_ai_unavailable") || "No pudimos leer la factura automáticamente en este momento. Volvé a intentar en unos minutos.");
          setShowUploadModal(false);
          return;
        }
        // _rowId identifica cada fila de forma única: un mismo PDF puede traer
        // varias facturas y compartir "filename" entre varias filas.
        setInvoiceResults(result.results.map((r, i) => ({ ...r, _rowId: `${r.filename}#${i}` })));
        setAppliedIndexes(new Set());
        setShowUploadModal(false);
        setShowInvoiceModal(true);
      } else {
        toast.error(result.msg || t("could_not_read_document"));
      }
    } catch (err) {
      toast.error(err?.msg || err?.message || t("error_processing_invoice"));
    } finally {
      setInvoiceLoading(false);
    }
  };

  const handleInvoiceFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    e.target.value = "";
    await processInvoiceFiles(files);
  };

  // Mapa: tipo de combustible detectado → campos del formulario
  const FUEL_FIELD_MAP = {
    diesel:      { value: "diesel.value",      cost: "diesel_cost.value" },
    gasoline:    { value: "gasoline.value",    cost: "gasoline_cost.value",  unit: "gasoline.unit" },
    natural_gas: { value: "natural_gas.value", cost: "natural_gas_cost.value", unit: "natural_gas.unit" },
    glp:         { value: "glp.value",         cost: "glp_cost.value",   unit: "glp.unit" },
    biodiesel:   { value: "biodiesel.value",   cost: "cost_biodiesel.value" },
    ethanol:     { value: "ethanol.value",     cost: "ethanol_cost.value" },
  };

  const handleApplyInvoiceData = (result) => {
    if (!result) return;

    // Clave mes+año+combustible. Varias facturas del mismo mes y combustible
    // que vienen en el MISMO archivo (un PDF con varias facturas) se SUMAN;
    // si la ya aplicada viene de otro archivo, se REEMPLAZA (criterio de la usuaria).
    const keyOf = (r) => (r.fuelType && r.period && r.year)
      ? `${parseInt(r.year, 10)}-${PERIOD_NUM_TO_NAME[String(r.period)] || r.period}-${r.fuelType}`
      : null;
    const resultKey = keyOf(result);
    const appliedSameKey = resultKey
      ? invoiceResults.filter(r => r._rowId !== result._rowId && appliedIndexes.has(r._rowId) && keyOf(r) === resultKey)
      : [];
    const sameKeyApplied = appliedSameKey.filter(r => r.filename === result.filename);
    const replacedRows   = appliedSameKey.filter(r => r.filename !== result.filename);

    // Aplicar volumen y costo al campo del tipo de combustible detectado
    if (result.fuelType && FUEL_FIELD_MAP[result.fuelType]) {
      const fields = FUEL_FIELD_MAP[result.fuelType];
      const sum = (key) => Math.round([result, ...sameKeyApplied]
        .reduce((s, r) => s + (r[key] != null ? Number(r[key]) : 0), 0) * 1000) / 1000;
      if (result.volume != null) formik.setFieldValue(fields.value, sum("volume"));
      if (result.cost   != null) formik.setFieldValue(fields.cost,  sum("cost"));
      if (result.unit   != null && fields.unit) formik.setFieldValue(fields.unit, result.unit);
    }

    const periodName = result.period ? (PERIOD_NUM_TO_NAME[result.period] || result.period) : null;
    const yearNum    = result.year   ? parseInt(result.year, 10) : null;

    if (yearNum)    formik.setFieldValue("year", yearNum);
    if (periodName) {
      if (listPeriods.includes(periodName)) {
        formik.setFieldValue("period", periodName);
      } else {
        toast.warning(`El período ${t(periodName)} ya está cargado para este año.`);
      }
    }

    // Las del mismo archivo quedan aplicadas (ya están sumadas arriba); las de
    // otro archivo con el mismo mes+combustible se reemplazan
    setAppliedIndexes(prev => {
      const next = new Set(prev);
      replacedRows.forEach(r => next.delete(r._rowId));
      next.add(result._rowId);
      return next;
    });
    toast.success(t("invoice_data_applied"));
  };

  // Guarda los resultados aplicados
  const handleSaveAllInvoiceData = async () => {
    const validResults = invoiceResults.filter(r => !r.error && r.period && r.year && appliedIndexes.has(r._rowId));
    if (!validResults.length) {
      toast.warning(t("no_valid_results_to_save") || "No hay resultados válidos para guardar.");
      return;
    }

    setBulkSaveLoading(true);
    setBulkSaveResults(null);

    const siteId = siteSelected || user?.site;
    const summary = { saved: [], skipped: [], errors: [] };

    // Agrupar por período+año para combinar distintos combustibles en un solo formulario
    const groups = new Map();
    for (const result of validResults) {
      const periodName = PERIOD_NUM_TO_NAME[String(result.period)] || result.period;
      const yearNum    = parseInt(result.year, 10);
      const key = `${yearNum}-${periodName}`;
      if (!groups.has(key)) groups.set(key, { periodName, yearNum, results: [] });
      groups.get(key).results.push(result);
    }

    for (const { periodName, yearNum, results } of groups.values()) {
      try {
        const existsResponse = await fuelsFormController.existsFuelsFormByPeriodAndYear(
          accessToken, siteId, periodName, yearNum
        );

        // Construir los campos de combustible (sirve tanto para create como para update).
        // Si el mes ya existe, estos valores REEMPLAZAN a los guardados.
        const fuelFields = {};
        const lastFileByField = {}; // archivo que cargó cada campo en este lote
        for (const result of results) {
          if (result.fuelType && FUEL_FIELD_MAP[result.fuelType]) {
            const fields   = FUEL_FIELD_MAP[result.fuelType];
            const fieldKey = fields.value.split(".")[0];
            const costKey  = fields.cost.split(".")[0];
            if (!fuelFields[fieldKey]) fuelFields[fieldKey] = {};
            if (!fuelFields[costKey])  fuelFields[costKey]  = {};
            // Varias facturas del mismo mes y combustible del MISMO archivo (un
            // PDF con varias facturas) se SUMAN; si vienen de otro archivo, la
            // última reemplaza (criterio de la usuaria)
            const sameFile = lastFileByField[fieldKey] === result.filename;
            const put = (prev, v) => sameFile ? Math.round(((Number(prev) || 0) + Number(v)) * 1000) / 1000 : Number(v);
            if (result.volume != null) fuelFields[fieldKey].value = put(fuelFields[fieldKey].value, result.volume);
            if (result.cost   != null) fuelFields[costKey].value  = put(fuelFields[costKey].value, result.cost);
            lastFileByField[fieldKey] = result.filename;
            const unitKey = fields.unit?.split(".")[0];
            if (result.unit != null && unitKey) {
              if (!fuelFields[unitKey]) fuelFields[unitKey] = {};
              fuelFields[unitKey].unit = result.unit;
            }
          }
        }

        if (existsResponse?.exist) {
          // El período ya existe → actualizar el formulario existente con los nuevos combustibles
          await fuelsFormController.updateFuelsForm(accessToken, existsResponse.id, fuelFields);
        } else {
          // Crear nuevo formulario
          const payload = initialValues(null, periodName, yearNum, unitsRecorded);
          payload.creator_user = user._id;
          payload.date         = new Date();
          payload.site         = siteId;
          Object.assign(payload, fuelFields);
          await fuelsFormController.createFuelsForm(accessToken, payload);
        }

        results.forEach(r => summary.saved.push({ period: periodName, year: yearNum, filename: r.filename }));
      } catch (err) {
        results.forEach(r => summary.errors.push({ period: periodName, year: yearNum, filename: r.filename, msg: err?.msg || err?.message }));
      }
    }

    setBulkSaveLoading(false);
    setBulkSaveResults(summary);
    if (summary.saved.length > 0) onReload?.();
    setTimeout(() => {
      const el = bulkSaveResultsRef.current;
      if (!el) return;
      const scrollContainer = el.closest(".scrolling.content") || el.closest(".modal .content") || el.closest(".content");
      if (scrollContainer) {
        scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior: "smooth" });
      } else {
        el.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }, 100);
  };

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  useEffect(() => {
    (async () => {
      try {
        const response =
          await fuelsFormController.getPeriodsFuelsFormsBySiteAndYear(
            accessToken,
            siteSelected,
            formik.values.year
          );
        const periods = PERIODS.map((item) => item);
        const availablePeriods = periods
          .filter((period) => !response.periods.includes(period))
          .map((period) => period);

        setListPeriods(availablePeriods);

        // Detectar si todos los meses del año están completos
        if (availablePeriods.length === 0) {
          setYearComplete(true);
        } else {
          setYearComplete(false);
        }
      } catch (error) {
        console.error(error);
        setListPeriods([]);
        setYearComplete(false);
      }
    })();
  }, [formik.values.year]);

  function findActiveFieldByName(nameToFind) {
    if (
      configFormData &&
      configFormData.fields &&
      configFormData.fields.length > 0
    ) {
      return configFormData.fields.some(
        (field) => field.name === nameToFind && field.active
      );
    }
    return true;
  }

  console.log(formik.errors);

  return (
    <Form className="fuels-form" onSubmit={formik.handleSubmit}>
      {fuelsForm ? (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "12px" }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="calendar alternate outline" style={{ margin: 0 }} />
            {fuelsForm.date ? formatDateView(fuelsForm.date) : "-"}
          </span>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="user outline" style={{ margin: 0 }} />
            {fuelsForm.creator_user
              ? fuelsForm.creator_user.lastname
                ? fuelsForm.creator_user.lastname + " " + fuelsForm.creator_user.firstname
                : fuelsForm.creator_user.email
              : "-"}
          </span>
        </div>
      ) : null}
      {!fuelsForm ? (
        <>
          <Grid columns={2} divided>
            <GridRow style={{ display: "flex", gap: "20px" }}>
              {/* Año */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("year")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={years.map((year) => ({
                        key: year,
                        text: year,
                        value: year,
                      }))}
                      selection
                      onChange={(_, data) =>
                        formik.setFieldValue("year", data.value)
                      }
                      value={formik.values.year}
                      error={!!formik.errors.year && !!formik.touched.year}
                      style={{ flex: 1 }}
                      name="year"
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.year && formik.errors.year}
                  </div>
                </div>
              </GridColumn>

              {/* Periodo */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("period")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={listPeriods.map((period) => ({
                        key: period,
                        text: t(period),
                        value: period,
                      }))}
                      selection
                      value={formik.values.period}
                      onChange={(_, data) => {
                        // Actualiza el valor
                        formik.setFieldValue("period", data.value);
                        // Marca el campo como tocado (opcional)
                        formik.setFieldTouched("period", true, false);
                        // Borra el error si hay uno
                        formik.setFieldError("period", undefined);
                      }}
                      error={!!formik.errors.period && !!formik.touched.period}
                      style={{ flex: 1 }}
                      name="period"
                      disabled={yearComplete}
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.period && formik.errors.period}
                  </div>
                </div>
              </GridColumn>
            </GridRow>
          </Grid>
          {/* Mensaje de advertencia cuando el año está completo */}
          {yearComplete && !fuelsForm && (
            <div
              style={{
                position: "fixed",
                top: "80px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "90%",
                maxWidth: "800px",
                zIndex: 99999,
                backgroundColor: "#fffef5",
                border: "1px solid #e8e8e8",
                borderRadius: "6px",
                padding: "15px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "1.1em", fontWeight: "600", color: "#666", marginBottom: "8px" }}>
                Meses del año completo
              </div>
              <p style={{ fontSize: "0.95em", margin: "0", color: "#555", lineHeight: "1.5" }}>
                Todos los periodos del año <strong>{formik.values.year}</strong> ya están cargados.
                <br />
                Por favor, seleccione otro año para crear un nuevo formulario.
                <br />
                Si desea editar un periodo existente, cierre esta ventana y seleccione el formulario a editar.
              </p>
            </div>
          )}
        </>
      ) : null}
      {/* Botón para habilitar edición de unidades (solo admin/master en modo edición) */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
        {canEditUnits && fuelsForm ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Button
              type="button"
              color={unitEditEnabled ? "orange" : "grey"}
              size="small"
              icon
              labelPosition="left"
              onClick={() => setUnitEditEnabled(!unitEditEnabled)}
            >
              <Icon name={unitEditEnabled ? "unlock" : "lock"} />
              {unitEditEnabled
                ? (t("disable_unit_edit") || "Deshabilitar edición de unidades")
                : (t("enable_unit_edit") || "Habilitar edición de unidades")
              }
            </Button>
            {unitEditEnabled && (
              <Message warning size="tiny" style={{ margin: 0, padding: "8px 12px" }}>
                <Icon name="warning sign" />
                {t("unit_edit_warning") || "Los cambios de unidad se registrarán en auditoría"}
              </Message>
            )}
          </div>
        ) : <div />}
        <Popup
          content={t("read_invoice_tooltip") || "Leer documento"}
          trigger={
            <Form.Button
              type="button"
              color="teal"
              size="small"
              icon="file alternate"
              loading={invoiceLoading}
              onClick={() => setShowUploadModal(true)}
            />
          }
        />
      </div>
      <Table className="fuels-form-table" unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width="1">{t("code")}</Table.HeaderCell>
            <Table.HeaderCell width="6">{t("concept")}</Table.HeaderCell>
            <Table.HeaderCell width="2">{t("value")}</Table.HeaderCell>
            <Table.HeaderCell width="2">{t("unit")}</Table.HeaderCell>
            <Table.HeaderCell width="2">{t("state")}</Table.HeaderCell>
            <Table.HeaderCell>{t("actions")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {findActiveFieldByName("natural_gas") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.natural_gas.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("natural_gas")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="natural_gas.value"
                  value={formik.values.natural_gas.value}
                  error={formik.errors.natural_gas?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.natural_gas?.unit &&
                    formik.touched.natural_gas?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.natural_gas.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("natural_gas").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("natural_gas.unit", data.value);
                      formik.setFieldTouched("natural_gas.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("natural_gas.unit", undefined);
                      }
                    }}
                    value={formik.values.natural_gas.unit}
                    error={
                      !!formik.errors.natural_gas?.unit &&
                      !!formik.touched.natural_gas?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.natural_gas?.unit &&
                        formik.touched.natural_gas?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="natural_gas.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`natural_gas.approvalStatus`, data.value)
                  }
                  value={formik.values.natural_gas.approvalStatus}
                  error={formik.errors.natural_gas?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.natural_gas.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.natural_gas.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("natural_gas"), "natural_gas");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"natural_gas"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("natural_gas_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.natural_gas_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("natural_gas_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="natural_gas_cost.value"
                  value={formik.values.natural_gas_cost.value}
                  error={formik.errors.natural_gas_cost?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.natural_gas_cost?.unit &&
                    formik.touched.natural_gas_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.natural_gas_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("natural_gas_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("natural_gas_cost.unit", data.value);
                      formik.setFieldTouched(
                        "natural_gas_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "natural_gas_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.natural_gas_cost.unit}
                    error={
                      !!formik.errors.natural_gas_cost?.unit &&
                      !!formik.touched.natural_gas_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.natural_gas_cost?.unit &&
                        formik.touched.natural_gas_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="natural_gas_cost.unit"
                  />
                </div>
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `natural_gas_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.natural_gas_cost.approvalStatus}
                  error={formik.errors.natural_gas_cost?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.natural_gas_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("natural_gas_cost"),
                          "natural_gas_cost"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"natural_gas_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("glp") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.glp.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("glp")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="glp.value"
                  value={formik.values.glp.value}
                  error={formik.errors.glp?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.glp?.unit && formik.touched.glp?.unit && (
                    <div style={{ color: "red", fontSize: "0.8em" }}>
                      {formik.errors.glp.unit}
                    </div>
                  )}
                  <Form.Dropdown
                    options={determineFuelsUnits("glp").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("glp.unit", data.value);
                      formik.setFieldTouched("glp.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("glp.unit", undefined);
                      }
                    }}
                    value={formik.values.glp.unit}
                    error={
                      !!formik.errors.glp?.unit && !!formik.touched.glp?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.glp?.unit && formik.touched.glp?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="glp.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`glp.approvalStatus`, data.value)
                  }
                  value={formik.values.glp.approvalStatus}
                  error={formik.errors.glp?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.glp.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.glp.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("glp"), "glp");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"glp"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("glp_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.glp_cost.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("glp_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="glp_cost.value"
                  value={formik.values.glp_cost.value}
                  error={formik.errors.glp_cost?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.glp_cost?.unit &&
                    formik.touched.glp_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.glp_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("glp_cost").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("glp_cost.unit", data.value);
                      formik.setFieldTouched("glp_cost.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("glp_cost.unit", undefined);
                      }
                    }}
                    value={formik.values.glp_cost.unit}
                    error={
                      !!formik.errors.glp_cost?.unit &&
                      !!formik.touched.glp_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.glp_cost?.unit &&
                        formik.touched.glp_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="glp_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`glp_cost.approvalStatus`, data.value)
                  }
                  value={formik.values.glp_cost.approvalStatus}
                  error={formik.errors.glp_cost?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.glp_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.glp_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("glp_cost"), "glp_cost");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"glp_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("diesel") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.diesel.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("diesel")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="diesel.value"
                  value={formik.values.diesel.value}
                  error={formik.errors.diesel?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.diesel?.unit &&
                    formik.touched.diesel?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.diesel.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("diesel").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("diesel.unit", data.value);
                      formik.setFieldTouched("diesel.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("diesel.unit", undefined);
                      }
                    }}
                    value={formik.values.diesel.unit}
                    error={
                      !!formik.errors.diesel?.unit &&
                      !!formik.touched.diesel?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.diesel?.unit &&
                        formik.touched.diesel?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="diesel.unit"
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`diesel.approvalStatus`, data.value)
                  }
                  value={formik.values.diesel.approvalStatus}
                  error={formik.errors.diesel?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.diesel.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.glp_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("diesel"), "diesel");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"diesel"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("diesel_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.diesel_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("diesel_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="diesel_cost.value"
                  value={formik.values.diesel_cost.value}
                  error={formik.errors.diesel_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.diesel_cost?.unit &&
                    formik.touched.diesel_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.diesel_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("diesel_cost").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("diesel_cost.unit", data.value);
                      formik.setFieldTouched("diesel_cost.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("diesel_cost.unit", undefined);
                      }
                    }}
                    value={formik.values.diesel_cost.unit}
                    error={
                      !!formik.errors.diesel_cost?.unit &&
                      !!formik.touched.diesel_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.diesel_cost?.unit &&
                        formik.touched.diesel_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="diesel_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`diesel_cost.approvalStatus`, data.value)
                  }
                  value={formik.values.diesel_cost.approvalStatus}
                  error={formik.errors.diesel_cost?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.diesel_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.glp_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("diesel_cost"), "diesel_cost");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"diesel_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("biodiesel") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.biodiesel.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biodiesel")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biodiesel.value"
                  value={formik.values.biodiesel.value}
                  error={formik.errors.biodiesel?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biodiesel?.unit &&
                    formik.touched.biodiesel?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biodiesel.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("biodiesel").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("biodiesel.unit", data.value);
                      formik.setFieldTouched("biodiesel.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("biodiesel.unit", undefined);
                      }
                    }}
                    value={formik.values.biodiesel.unit}
                    error={
                      !!formik.errors.biodiesel?.unit &&
                      !!formik.touched.biodiesel?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biodiesel?.unit &&
                        formik.touched.biodiesel?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="biodiesel.unit"
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`biodiesel.approvalStatus`, data.value)
                  }
                  value={formik.values.biodiesel.approvalStatus}
                  error={formik.errors.biodiesel?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.biodiesel.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biodiesel.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("biodiesel"), "biodiesel");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biodiesel"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("cost_biodiesel") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.cost_biodiesel.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("cost_biodiesel")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="cost_biodiesel.value"
                  value={formik.values.cost_biodiesel.value}
                  error={formik.errors.cost_biodiesel?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.cost_biodiesel?.unit &&
                    formik.touched.cost_biodiesel?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.cost_biodiesel.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("cost_biodiesel").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("cost_biodiesel.unit", data.value);
                      formik.setFieldTouched(
                        "cost_biodiesel.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("cost_biodiesel.unit", undefined);
                      }
                    }}
                    value={formik.values.cost_biodiesel.unit}
                    error={
                      !!formik.errors.cost_biodiesel?.unit &&
                      !!formik.touched.cost_biodiesel?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.cost_biodiesel?.unit &&
                        formik.touched.cost_biodiesel?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="cost_biodiesel.unit"
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `cost_biodiesel.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.cost_biodiesel.approvalStatus}
                  error={formik.errors.cost_biodiesel?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.cost_biodiesel.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.cost_biodiesel.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("cost_biodiesel"), "cost_biodiesel");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"cost_biodiesel"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("gasoline") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.gasoline.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("gasoline")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="gasoline.value"
                  value={formik.values.gasoline.value}
                  error={formik.errors.gasoline?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.gasoline?.unit &&
                    formik.touched.gasoline?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.gasoline.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("gasoline").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("gasoline.unit", data.value);
                      formik.setFieldTouched("gasoline.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("gasoline.unit", undefined);
                      }
                    }}
                    value={formik.values.gasoline.unit}
                    error={
                      !!formik.errors.gasoline?.unit &&
                      !!formik.touched.gasoline?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.gasoline?.unit &&
                        formik.touched.gasoline?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="gasoline.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`gasoline.approvalStatus`, data.value)
                  }
                  value={formik.values.gasoline.approvalStatus}
                  error={formik.errors.gasoline?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.gasoline.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.cost_biodiesel.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("gasoline"), "gasoline");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"gasoline"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("gasoline_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.gasoline_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("gasoline_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="gasoline_cost.value"
                  value={formik.values.gasoline_cost.value}
                  error={formik.errors.gasoline_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.gasoline_cost?.unit &&
                    formik.touched.gasoline_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.gasoline_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("gasoline_cost").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("gasoline_cost.unit", data.value);
                      formik.setFieldTouched("gasoline_cost.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("gasoline_cost.unit", undefined);
                      }
                    }}
                    value={formik.values.gasoline_cost.unit}
                    error={
                      !!formik.errors.gasoline_cost?.unit &&
                      !!formik.touched.gasoline_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.gasoline_cost?.unit &&
                        formik.touched.gasoline_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="gasoline_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`gasoline_cost.approvalStatus`, data.value)
                  }
                  value={formik.values.gasoline_cost.approvalStatus}
                  error={formik.errors.gasoline_cost?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.gasoline_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.cost_biodiesel.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("gasoline_cost"), "gasoline_cost");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"gasoline_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("ethanol") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.ethanol.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("ethanol")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="ethanol.value"
                  value={formik.values.ethanol.value}
                  error={formik.errors.ethanol?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.ethanol?.unit &&
                    formik.touched.ethanol?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.ethanol.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("ethanol").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("ethanol.unit", data.value);
                      formik.setFieldTouched("ethanol.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("ethanol.unit", undefined);
                      }
                    }}
                    value={formik.values.ethanol.unit}
                    error={
                      !!formik.errors.ethanol?.unit &&
                      !!formik.touched.ethanol?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.ethanol?.unit &&
                        formik.touched.ethanol?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="ethanol.unit"
                  />
                </div>
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`ethanol.approvalStatus`, data.value)
                  }
                  value={formik.values.ethanol.approvalStatus}
                  error={formik.errors.ethanol?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.ethanol.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.ethanol.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("ethanol"), "ethanol");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"ethanol"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("ethanol_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.ethanol_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("ethanol_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="ethanol_cost.value"
                  value={formik.values.ethanol_cost.value}
                  error={formik.errors.ethanol_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.ethanol_cost?.unit &&
                    formik.touched.ethanol_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.ethanol_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("ethanol_cost").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("ethanol_cost.unit", data.value);
                      formik.setFieldTouched("ethanol_cost.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("ethanol_cost.unit", undefined);
                      }
                    }}
                    value={formik.values.ethanol_cost.unit}
                    error={
                      !!formik.errors.ethanol_cost?.unit &&
                      !!formik.touched.ethanol_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.ethanol_cost?.unit &&
                        formik.touched.ethanol_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="ethanol_cost.unit"
                  />
                </div>
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`ethanol_cost.approvalStatus`, data.value)
                  }
                  value={formik.values.ethanol_cost.approvalStatus}
                  error={formik.errors.ethanol_cost?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.ethanol_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.ethanol_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("ethanol_cost"), "ethanol_cost");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"ethanol_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("electricity_vehicles") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.electricity_vehicles.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("electricity_vehicles")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="electricity_vehicles.value"
                  value={formik.values.electricity_vehicles.value}
                  error={formik.errors.electricity_vehicles?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.electricity_vehicles?.unit &&
                    formik.touched.electricity_vehicles?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.electricity_vehicles.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("electricity_vehicles").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "electricity_vehicles.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "electricity_vehicles.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "electricity_vehicles.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.electricity_vehicles.unit}
                    error={
                      !!formik.errors.electricity_vehicles?.unit &&
                      !!formik.touched.electricity_vehicles?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.electricity_vehicles?.unit &&
                        formik.touched.electricity_vehicles?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="electricity_vehicles.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `electricity_vehicles.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.electricity_vehicles.approvalStatus}
                  error={formik.errors.electricity_vehicles?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.electricity_vehicles.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_for_internal_vehicles.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("electricity_vehicles"),
                          "electricity_vehicles"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"electricity_vehicles"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("cost_electricity_vehicles") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.cost_electricity_vehicles.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("cost_electricity_vehicles")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="cost_electricity_vehicles.value"
                  value={formik.values.cost_electricity_vehicles.value}
                  error={formik.errors.cost_electricity_vehicles?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.cost_electricity_vehicles?.unit &&
                    formik.touched.cost_electricity_vehicles?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.cost_electricity_vehicles.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits(
                      "cost_electricity_vehicles"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "cost_electricity_vehicles.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "cost_electricity_vehicles.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "cost_electricity_vehicles.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.cost_electricity_vehicles.unit}
                    error={
                      !!formik.errors.cost_electricity_vehicles?.unit &&
                      !!formik.touched.cost_electricity_vehicles?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.cost_electricity_vehicles?.unit &&
                        formik.touched.cost_electricity_vehicles?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="cost_electricity_vehicles.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `cost_electricity_vehicles.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.cost_electricity_vehicles.approvalStatus}
                  error={formik.errors.cost_electricity_vehicles?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.cost_electricity_vehicles.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_for_internal_vehicles.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("cost_electricity_vehicles"),
                          "cost_electricity_vehicles"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"cost_electricity_vehicles"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("natural_gas_vehicles") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.natural_gas_vehicles.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("natural_gas_vehicles")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="natural_gas_vehicles.value"
                  value={formik.values.natural_gas_vehicles.value}
                  error={formik.errors.natural_gas_vehicles?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.natural_gas_vehicles?.unit &&
                    formik.touched.natural_gas_vehicles?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.natural_gas_vehicles.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("natural_gas_vehicles").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "natural_gas_vehicles.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "natural_gas_vehicles.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "natural_gas_vehicles.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.natural_gas_vehicles.unit}
                    error={
                      !!formik.errors.natural_gas_vehicles?.unit &&
                      !!formik.touched.natural_gas_vehicles?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.natural_gas_vehicles?.unit &&
                        formik.touched.natural_gas_vehicles?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="natural_gas_vehicles.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `natural_gas_vehicles.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.natural_gas_vehicles.approvalStatus}
                  error={formik.errors.natural_gas_vehicles?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.natural_gas_vehicles.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_for_internal_vehicles.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("natural_gas_vehicles"),
                          "natural_gas_vehicles"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"natural_gas_vehicles"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("glp_vehicles") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.glp_vehicles.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("glp_vehicles")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="glp_vehicles.value"
                  value={formik.values.glp_vehicles.value}
                  error={formik.errors.glp_vehicles?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.glp_vehicles?.unit &&
                    formik.touched.glp_vehicles?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.glp_vehicles.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("glp_vehicles").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("glp_vehicles.unit", data.value);
                      formik.setFieldTouched("glp_vehicles.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("glp_vehicles.unit", undefined);
                      }
                    }}
                    value={formik.values.glp_vehicles.unit}
                    error={
                      !!formik.errors.glp_vehicles?.unit &&
                      !!formik.touched.glp_vehicles?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.glp_vehicles?.unit &&
                        formik.touched.glp_vehicles?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="glp_vehicles.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(`glp_vehicles.approvalStatus`, data.value)
                  }
                  value={formik.values.glp_vehicles.approvalStatus}
                  error={formik.errors.glp_vehicles?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.glp_vehicles.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_for_internal_vehicles.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("glp_vehicles"), "glp_vehicles");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"glp_vehicles"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("diesel_vehicles") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.diesel_vehicles.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("diesel_vehicles")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="diesel_vehicles.value"
                  value={formik.values.diesel_vehicles.value}
                  error={formik.errors.diesel_vehicles?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.diesel_vehicles?.unit &&
                    formik.touched.diesel_vehicles?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.diesel_vehicles.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("diesel_vehicles").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("diesel_vehicles.unit", data.value);
                      formik.setFieldTouched(
                        "diesel_vehicles.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("diesel_vehicles.unit", undefined);
                      }
                    }}
                    value={formik.values.diesel_vehicles.unit}
                    error={
                      !!formik.errors.diesel_vehicles?.unit &&
                      !!formik.touched.diesel_vehicles?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.diesel_vehicles?.unit &&
                        formik.touched.diesel_vehicles?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="diesel_vehicles.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `diesel_vehicles.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.diesel_vehicles.approvalStatus}
                  error={formik.errors.diesel_vehicles?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.diesel_vehicles.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_for_internal_vehicles.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(t("diesel_vehicles"), "diesel_vehicles");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"diesel_vehicles"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("biodiesel_vehicles") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biodiesel_vehicles.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biodiesel_vehicles")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biodiesel_vehicles.value"
                  value={formik.values.biodiesel_vehicles.value}
                  error={formik.errors.biodiesel_vehicles?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biodiesel_vehicles?.unit &&
                    formik.touched.biodiesel_vehicles?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biodiesel_vehicles.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("biodiesel_vehicles").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biodiesel_vehicles.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biodiesel_vehicles.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biodiesel_vehicles.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biodiesel_vehicles.unit}
                    error={
                      !!formik.errors.biodiesel_vehicles?.unit &&
                      !!formik.touched.biodiesel_vehicles?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biodiesel_vehicles?.unit &&
                        formik.touched.biodiesel_vehicles?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="biodiesel_vehicles.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biodiesel_vehicles.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biodiesel_vehicles.approvalStatus}
                  error={formik.errors.biodiesel_vehicles?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.biodiesel_vehicles.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_for_internal_vehicles.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biodiesel_vehicles"),
                          "biodiesel_vehicles"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biodiesel_vehicles"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("gasoline_vehicles") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.gasoline_vehicles.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("gasoline_vehicles")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="gasoline_vehicles.value"
                  value={formik.values.gasoline_vehicles.value}
                  error={formik.errors.gasoline_vehicles?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.gasoline_vehicles?.unit &&
                    formik.touched.gasoline_vehicles?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.gasoline_vehicles.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("gasoline_vehicles").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "gasoline_vehicles.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "gasoline_vehicles.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "gasoline_vehicles.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.gasoline_vehicles.unit}
                    error={
                      !!formik.errors.gasoline_vehicles?.unit &&
                      !!formik.touched.gasoline_vehicles?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.gasoline_vehicles?.unit &&
                        formik.touched.gasoline_vehicles?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="gasoline_vehicles.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `gasoline_vehicles.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.gasoline_vehicles.approvalStatus}
                  error={formik.errors.gasoline_vehicles?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.gasoline_vehicles.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_for_internal_vehicles.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("gasoline_vehicles"),
                          "gasoline_vehicles"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"gasoline_vehicles"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("ethanol_vehicles") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.ethanol_vehicles.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("ethanol_vehicles")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="ethanol_vehicles.value"
                  value={formik.values.ethanol_vehicles.value}
                  error={formik.errors.ethanol_vehicles?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.ethanol_vehicles?.unit &&
                    formik.touched.ethanol_vehicles?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.ethanol_vehicles.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("ethanol_vehicles").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("ethanol_vehicles.unit", data.value);
                      formik.setFieldTouched(
                        "ethanol_vehicles.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "ethanol_vehicles.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.ethanol_vehicles.unit}
                    error={
                      !!formik.errors.ethanol_vehicles?.unit &&
                      !!formik.touched.ethanol_vehicles?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.ethanol_vehicles?.unit &&
                        formik.touched.ethanol_vehicles?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="ethanol_vehicles.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `ethanol_vehicles.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.ethanol_vehicles.approvalStatus}
                  error={formik.errors.ethanol_vehicles?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.ethanol_vehicles.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_for_internal_vehicles.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("ethanol_vehicles"),
                          "ethanol_vehicles"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"ethanol_vehicles"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("electric_vehicles") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.electric_vehicles.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("electric_vehicles")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  onKeyPress={(event) => {
                    if (event.target.value === "0") event.target.value = "";

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="electric_vehicles.value"
                  value={formik.values.electric_vehicles.value}
                  error={formik.errors.electric_vehicles?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.electric_vehicles?.unit &&
                    formik.touched.electric_vehicles?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.electric_vehicles.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineFuelsUnits("electric_vehicles").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "electric_vehicles.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "electric_vehicles.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "electric_vehicles.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.electric_vehicles.unit}
                    error={
                      !!formik.errors.electric_vehicles?.unit &&
                      !!formik.touched.electric_vehicles?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.electric_vehicles?.unit &&
                        formik.touched.electric_vehicles?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="electric_vehicles.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `electric_vehicles.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.electric_vehicles.approvalStatus}
                  error={formik.errors.electric_vehicles?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(formik.values.electric_vehicles.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_for_internal_vehicles.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("electric_vehicles"),
                          "electric_vehicles"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"electric_vehicles"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
        </Table.Body>
      </Table>

      <ToastContainer
        position="bottom-center"
        autoClose={1200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <BasicModal
                        show={showModal}
                        onClose={() => setShowModal(false)}       // cerrar desde aquí
                        title={titleModal}
                        size="tiny"
                        closeOnDimmerClick={false}             // evita cierre al hacer clic fuera
                        closeOnEscape={false}                   // opcional
                      >
                        
                        <div onClick={(e) => e.stopPropagation()}>
        <Comments
          formik={formik}
          fieldName={fieldName}
          onClose={() => setShowModal(false)}
          onReload={onReload}
          fuelsForm={fuelsForm}
          user={user}
          t={t}
        /></div>
      </BasicModal>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "0.5rem",
          marginRight: 20,
          marginTop: 20,
          alignItems: "center",
        }}
      >
        <Button
          type="submit"
          primary
          size="large"
          loading={formik.isSubmitting}
          content={!fuelsForm ? t("save") : t("update")}
        />

        <Button
          type="button"
          color="red"
          secondary
          size="large"
          onClick={() => {
            onClose ? onClose() : goBack();
          }}
        >
          {t("cancel")}
        </Button>
      </div>

      <Modal open={showUploadModal} onClose={() => !invoiceLoading && setShowUploadModal(false)} size="small" closeOnDimmerClick={!invoiceLoading} className="invoice-reader-modal">
        <Modal.Header><Icon name="file alternate outline" /> {t("read_invoice") || "Leer documento"}</Modal.Header>
        <Modal.Content>
          <InvoiceDropzone onFiles={processInvoiceFiles} loading={invoiceLoading} t={t} inputRef={invoiceInputRef} onInputChange={handleInvoiceFileChange} />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => setShowUploadModal(false)} disabled={invoiceLoading}>{t("cancel")}</Button>
        </Modal.Actions>
      </Modal>

      <Modal open={showInvoiceModal} onClose={() => { setShowInvoiceModal(false); setBulkSaveResults(null); }} size="small" closeOnDimmerClick={false} className="invoice-preview-modal">
        <Modal.Header><Icon name="file alternate outline" /> {t("extracted_invoice_data") || "Datos extraídos"}</Modal.Header>
        <Modal.Content scrolling>
          {invoiceResults.length > 0 && (() => {
            const sorted = [...invoiceResults].sort((a, b) => {
              if (a.error && !b.error) return 1;
              if (!a.error && b.error) return -1;
              const yearDiff = (b.year || 0) - (a.year || 0);
              if (yearDiff !== 0) return yearDiff;
              return (b.period || 0) - (a.period || 0);
            });

            const groups = [];
            const groupMap = new Map();
            sorted.forEach(r => {
              const key = r.error ? "__errors__" : (r.year && r.period ? `${r.year}-${r.period}` : "__unknown__");
              if (!groupMap.has(key)) {
                groupMap.set(key, { key, year: r.year, period: r.period, isError: !!r.error, isUnknown: !r.year || !r.period, rows: [] });
                groups.push(groupMap.get(key));
              }
              groupMap.get(key).rows.push(r);
            });

            const MONTH_NAMES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];

            return (
              <div className="invoice-reader-preview">
                <Message info size="small" style={{ marginBottom: "0.75rem" }}>
                  <Icon name="info circle" />
                  {t("review_invoice_instructions") || "Aplicá las filas que querés incluir, luego hacé clic en Guardar."}
                </Message>
                {invoiceResults.some((r) => r.needsReview) && (
                  <Message warning size="small" style={{ marginBottom: "0.75rem" }}>
                    <Icon name="warning sign" />
                    {`Se detectaron ${invoiceResults.find((r) => r.needsReview)?.pagesDetected} páginas pero solo se pudo extraer 1 factura. Revisá los datos con cuidado antes de guardar — puede haber varios meses mezclados en una sola fila.`}
                  </Message>
                )}
                <Table size="small" compact>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>{t("file") || "Archivo"}</Table.HeaderCell>
                      <Table.HeaderCell>{t("fuel_type") || "Combustible"}</Table.HeaderCell>
                      <Table.HeaderCell>{t("volume") || "Volumen (L)"}</Table.HeaderCell>
                      <Table.HeaderCell>{t("cost") || "Costo"}</Table.HeaderCell>
                      <Table.HeaderCell></Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {groups.map(group => (
                      <React.Fragment key={group.key}>
                        <Table.Row>
                          <Table.Cell
                            colSpan={5}
                            style={{ background: group.isError ? "#fff0f0" : "#f0f4f9", padding: "5px 10px", borderTop: "2px solid #d0dce8" }}
                          >
                            <Icon
                              name={group.isError ? "exclamation triangle" : "calendar alternate outline"}
                              style={{ color: group.isError ? "#c0392b" : "#648EBC" }}
                            />
                            <strong style={{ fontSize: "0.88em", color: group.isError ? "#c0392b" : "#2c5282" }}>
                              {group.isError
                                ? (t("errors") || "Errores")
                                : group.isUnknown
                                  ? (t("period_not_detected") || "Período no detectado")
                                  : `${MONTH_NAMES[(group.period || 1) - 1]} ${group.year}`}
                            </strong>
                            <span style={{ marginLeft: "8px", fontSize: "0.78em", color: "#888" }}>
                              ({group.rows.length} {group.rows.length === 1 ? (t("file") || "archivo") : (t("files") || "archivos")})
                            </span>
                          </Table.Cell>
                        </Table.Row>
                        {group.rows.map((r, i) => (
                          <Table.Row key={r._rowId || i} negative={!!r.error}>
                            <Table.Cell>
                              <Icon name="paperclip" />
                              <span style={{ fontSize: "0.85em" }}>{r.filename}</span>
                              {r.format && <span style={{ marginLeft: "0.4rem", background: "#e8f4fd", color: "#1a6ba0", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600, textTransform: "uppercase" }}>{r.format}</span>}
                            </Table.Cell>
                            <Table.Cell>
                              {r.error ? "—" : r.fuelType
                                ? <strong>{t(r.fuelType) || r.fuelType}</strong>
                                : <span style={{ color: "#aaa" }}>{t("not_detected") || "No detectado"}</span>}
                            </Table.Cell>
                            <Table.Cell>
                              {r.error
                                ? <span style={{ color: "red" }}>{r.error}</span>
                                : r.volume != null
                                  ? <strong>{formatInvoiceQuantity(r.volume, language)} {r.unit || "L"}</strong>
                                  : <span style={{ color: "#aaa" }}>{t("not_detected") || "No detectado"}</span>}
                            </Table.Cell>
                            <Table.Cell>
                              {r.error ? "—" : r.cost != null
                                ? (
                                  <>
                                    <strong style={{ whiteSpace: "nowrap" }}>{invoiceCurrencySymbol(r.currency)} {formatInvoiceAmount(r.cost, r.currency, language)}</strong>
                                    {r.currency && <span style={INVOICE_CURRENCY_BADGE_STYLE}>{r.currency}</span>}
                                  </>
                                )
                                : <span style={{ color: "#aaa" }}>{t("not_detected") || "No detectado"}</span>}
                            </Table.Cell>
                            <Table.Cell>
                              {!r.error && (() => {
                                const btnStyle = { padding: "0.35em 0.75em", lineHeight: 1 };
                                if (appliedIndexes.has(r._rowId)) {
                                  return (
                                    <Button size="mini" color="green" disabled style={btnStyle}>
                                      <Icon name="check" /> {t("applied") || "Aplicado"}
                                    </Button>
                                  );
                                }
                                const conflicts = r.fuelType && r.period && r.year ? invoiceResults.filter(
                                  other => other._rowId !== r._rowId &&
                                    appliedIndexes.has(other._rowId) &&
                                    other.fuelType === r.fuelType &&
                                    other.period === r.period &&
                                    other.year === r.year
                                ) : [];
                                // Ya hay otra del mismo mes y combustible aplicada:
                                // del mismo archivo se suma, de otro archivo se reemplaza
                                if (conflicts.some(other => other.filename === r.filename)) {
                                  return (
                                    <Button size="mini" basic color="orange" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                      <Icon name="plus" /> {t("add_to_month") || "Sumar"}
                                    </Button>
                                  );
                                }
                                return conflicts.length > 0
                                  ? <Button size="mini" basic color="orange" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                      <Icon name="refresh" /> {t("replace") || "Reemplazar"}
                                    </Button>
                                  : <Button size="mini" color="teal" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                      <Icon name="check" /> {t("apply") || "Aplicar"}
                                    </Button>;
                              })()}
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </React.Fragment>
                    ))}
                  </Table.Body>
                </Table>
              </div>
            );
          })()}
          <div ref={bulkSaveResultsRef} />
          {bulkSaveResults && (() => {
            const renderFileList = (items, color) => (
              <ul style={{ margin: "4px 0 0 16px", padding: 0, listStyle: "none" }}>
                {items.map((item, i) => (
                  <li key={i} style={{ fontSize: "0.82em", color: "#555", marginBottom: 2 }}>
                    <Icon name="file alternate outline" style={{ color }} />
                    <strong>{t(item.period)} {item.year}</strong>
                    {item.filename && <span style={{ marginLeft: 6, color: "#888" }}>— {item.filename}</span>}
                    {item.msg && <span style={{ marginLeft: 6, color: "#c0392b" }}>({item.msg})</span>}
                  </li>
                ))}
              </ul>
            );
            return (
              <Message
                success={bulkSaveResults.errors.length === 0 && bulkSaveResults.saved.length > 0}
                warning={bulkSaveResults.errors.length > 0 || bulkSaveResults.saved.length === 0}
                style={{ marginTop: "1rem" }}
              >
                <Message.Header>{t("bulk_save_result") || "Resultado del guardado"}</Message.Header>
                {bulkSaveResults.saved.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="check circle" color="green" />
                    <strong style={{ color: "#27ae60" }}>
                      {bulkSaveResults.saved.length} {t("bulk_saved_ok") || "guardados correctamente"}
                    </strong>
                    {renderFileList(bulkSaveResults.saved, "#27ae60")}
                  </div>
                )}
                {bulkSaveResults.skipped.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="warning sign" color="yellow" />
                    <strong style={{ color: "#e67e22" }}>
                      {bulkSaveResults.skipped.length} {t("bulk_skipped") || "omitidos (período ya existía)"}
                    </strong>
                    {renderFileList(bulkSaveResults.skipped, "#e67e22")}
                  </div>
                )}
                {bulkSaveResults.errors.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="times circle" color="red" />
                    <strong style={{ color: "#c0392b" }}>
                      {bulkSaveResults.errors.length} {t("bulk_errors") || "con error al guardar"}
                    </strong>
                    {renderFileList(bulkSaveResults.errors, "#c0392b")}
                  </div>
                )}
              </Message>
            );
          })()}
        </Modal.Content>
        <Modal.Actions>
          {appliedIndexes.size > 0 && (
            <Button
              primary
              onClick={handleSaveAllInvoiceData}
              loading={bulkSaveLoading}
              disabled={bulkSaveLoading || !!bulkSaveResults}
            >
              <Icon name="save" /> {`${t("save_applied") || "Guardar"} (${appliedIndexes.size})`}
            </Button>
          )}
          <Button secondary onClick={() => { setShowInvoiceModal(false); setBulkSaveResults(null); }} disabled={bulkSaveLoading}>
            <Icon name="close" /> {t("close") || "Cerrar"}
          </Button>
        </Modal.Actions>
      </Modal>
    </Form>
  );
}

function InvoiceDropzone({ onFiles, loading, t, inputRef, onInputChange }) {
  const [isDragOver, setIsDragOver] = useState(false);
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "application/pdf": [], "image/*": [], "text/csv": [], "application/vnd.ms-excel": [], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], "text/plain": [] },
    multiple: true, disabled: loading, noClick: true, noKeyboard: true,
    onDrop: (accepted) => { if (accepted.length > 0) onFiles(accepted); },
    onDragEnter: () => setIsDragOver(true),
    onDragLeave: () => setIsDragOver(false),
    onDropAccepted: () => setIsDragOver(false),
    onDropRejected: () => setIsDragOver(false),
  });
  return (
    <div {...getRootProps()} style={{ border: `2px dashed ${isDragOver ? "#648EBC" : "#b0c4de"}`, borderRadius: "12px", padding: "2.5rem 1.5rem", minHeight: "260px", textAlign: "center", cursor: loading ? "not-allowed" : "pointer", background: isDragOver ? "#f0f6ff" : "#fafafa", transition: "all 0.2s ease", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1rem" }}>
      <input {...getInputProps()} />
      <input ref={inputRef} type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,.csv,.xlsx,.xls,.txt" multiple style={{ display: "none" }} onChange={onInputChange} />
      {loading ? (
        <><img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="sustemia" className="invoice-dropzone-spinner" /><p style={{ color: "#648EBC", fontWeight: 600 }}>{t("processing")}</p></>
      ) : (
        <><Icon name="cloud upload" size="huge" color="blue" style={{ margin: 0 }} />
          <p style={{ margin: 0, fontSize: "1rem", fontWeight: 500, color: "#333" }}>{t("drag_drop_files")}</p>
          <p style={{ margin: 0, color: "#888", fontSize: "0.85rem" }}>o</p>
          <Button type="button" primary onClick={(e) => { e.stopPropagation(); inputRef.current?.click(); }}><Icon name="folder open outline" />{t("select_files")}</Button>
          <p style={{ margin: 0, color: "#aaa", fontSize: "0.75rem" }}>{t("supported_formats")}</p>
        </>
      )}
    </div>
  );
}

function Comments({ formik, user, fieldName, onClose, t }) {
  const [comment, setComment] = useState("");

  const handleAddComment = () => {
    if (comment.trim().length > 0) {
      const reviews = [...(formik.values[fieldName].reviews || [])];

      reviews.push({
        comments: comment.trim(),
        date: new Date(),
        reviewer_user: user ? user._id : null,
      });

      formik.setFieldValue(`${fieldName}.reviews`, reviews);
      setComment("");
    }
  };

  const handleSaveComment = (id, editedContent) => {
    const reviews = [...formik.values[fieldName].reviews];
    reviews[id] = {
      ...reviews[id],
      comments: editedContent.trim(),
      date: new Date(),
    };
    formik.setFieldValue(`${fieldName}.reviews`, reviews);
  };

  const reviews = formik.values[fieldName]?.reviews || [];

  return (
    <CommentGroup minimal>
      <Header as="h4" dividing>{t("comments")}</Header>
      {reviews.map((review, index) => (
    
        <React.Fragment key={index}>
          <EditableComment
            id={index}
            author={
              review.reviewer_user
                ? review.reviewer_user === user._id
                  ? `${user.firstname} ${user.lastname}`
                  : `${review.reviewer_user.firstname} ${review.reviewer_user.lastname}`
                : ""
            }
            date={formatDateHourCompleted(review.date)}
            content={review.comments}
            onSave={handleSaveComment}
            active={review.reviewer_user === user._id}
            t={t}
          />
          <Divider fitted />    {console.log(review)}
        </React.Fragment>
      ))}


      {/* ✨ Form con preventDefault para evitar submit accidental */}
      <Form reply className="comments-reply-form" onSubmit={(e) => e.preventDefault()}>
        <Form.TextArea
          placeholder={t("write_a_comment")}
          rows={3}
          style={{ minHeight: 100 }}
          onChange={(_, data) => setComment(data.value)}
          value={comment}
        />

        <div style={{ display: "flex", gap: "1em", marginTop: "1em", justifyContent: "center" }}>
          <Button
            type="button" // importante para no disparar submit
            content="Añadir"
            primary
            size="small"
            style={{ minWidth: 100 }}
            onClick={handleAddComment}
          />
          <Button
            type="button" // importante para no disparar submit
            content={t("close")}
            secondary
            size="small"
            style={{ minWidth: 100 }}
            onClick={onClose}
          />
        </div>
      </Form>
    </CommentGroup>
  );
}
function EditableComment({ id, author, date, content, onSave, active, t }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(content);

  const handleChange = (e) => setEditedContent(e.target.value);
  const handleEdit = () => setIsEditing(true);
  const handleCancel = () => {
    setEditedContent(content);
    setIsEditing(false);
  };
  const handleSave = () => {
    if (editedContent.trim()) {
      onSave(id, editedContent);
      setIsEditing(false);
    }
  };

  const initials = author
    ? author.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  return (
    <div style={{
      display: 'flex',
      gap: '10px',
      padding: '10px 12px',
      borderRadius: '10px',
      backgroundColor: '#f4f6f9',
      marginBottom: '8px',
    }}>
      <div style={{
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        backgroundColor: '#648EBC',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: '700',
        flexShrink: 0,
      }}>
        {initials}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '4px' }}>
          <span style={{ fontWeight: '700', fontSize: '13px', color: '#1A1C40' }}>{author}</span>
          <span style={{ fontSize: '11px', color: '#999' }}>{date}</span>
        </div>
        {isEditing ? (
          <Form reply>
            <Form.TextArea value={editedContent} onChange={handleChange} rows={3} />
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem", justifyContent: "center" }}>
              <Button type="button" icon="check" circular primary className="btn-comment-edit-action" onClick={handleSave} />
              <Button type="button" icon="times" circular secondary className="btn-comment-edit-action" onClick={handleCancel} />
            </div>
          </Form>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
            <p style={{ margin: 0, fontSize: '13px', color: '#333', wordBreak: 'break-word' }}>{content}</p>
            {active && (
              <Icon
                name="pencil"
                size="small"
                style={{ cursor: 'pointer', color: '#aaa', flexShrink: 0, marginTop: '2px' }}
                onClick={handleEdit}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function FileViewer(props) {
  const { fileName, fileUniqueName, handleRemove, t } = props;
  const [fileUrl, setFileUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (fileName) {
      setFileUrl(fileName); // Construye la URL del archivo
      (async () => {
        try {
          const response = await fuelsFormController.getFileApi(fileUniqueName);
          setFileUrl(response); // Construye la URL del archivo
          //console.log(setFileUrl);
          //setMessage(response.message);
        } catch (error) {
          //setMessage('Error al elimianr el archivo');
        }
      })();
    }
  }, [fileName]);

  const handleOpenPreview = (event) => {
    event.preventDefault();
    setPreviewOpen(true);
  };

  const handleClosePreview = (event) => {
    event.preventDefault(); // Previene el comportamiento predeterminado
    setPreviewOpen(false);
  };

  return (
    <>
      <List.Content floated="left">{fileName}</List.Content>
      <List.Content floated="right">
        {" "}
        <Button
          color="red"
          onClick={() => handleRemove(fileUniqueName)}
          icon="trash alternate"
        />
      </List.Content>
      {/* //<Button onClick={handleOpenPreview}> {fileName}</Button> */}
      <List.Content floated="right">
        <Modal
          onClose={handleClosePreview}
          onOpen={handleOpenPreview}
          open={previewOpen}
          trigger={
            <Button primary icon>
              <Icon name="eye" />
            </Button>
          }
        >
          <ModalHeader>{fileName}</ModalHeader>
          <ModalContent>
            {fileName &&
              (fileName.endsWith(".jpg") ||
                fileName.endsWith(".png") ||
                fileName.endsWith(".jpeg")) && (
                <Image
                  src={fileUrl}
                  alt="Vista previa"
                  style={{ maxWidth: "100%" }}
                />
              )}
            {fileName && fileName.endsWith(".pdf") && (
              <iframe
                src={fileUrl}
                title={t("preview")}
                style={{ width: "100%", height: "500px" }}
              />
            )}
          </ModalContent>
          <ModalActions>
            {/* <Button color="red" onClick={() => handleRemove(fileName)}>
            <Icon disabled name="trash alternate" /> Eliminar
          </Button> */}
            <Button color="black" onClick={handleClosePreview}>
              <Icon disabled name="close" />
              {t("close")}
            </Button>
          </ModalActions>
        </Modal>
      </List.Content>
    </>
  );
}

function FileUpload(props) {
  const { accessToken, data, field, newFiles, setNewFiles, t } = props;
  const [files, setFiles] = useState([]);
  const [filesView, setFilesView] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openModal, setOpenModal] = useState(false); // Para controlar el estado del modal

  useEffect(() => {
    if (data.values[field].files) {
      setFilesView(data.values[field].files); // Construye la URL del archivo
    }
  }, [data]);

  const handleButtonClick = (event) => {
    event.preventDefault(); // Evita que el formulario se envíe
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.onchange = handleFileChange;
    input.click();
  };

  // Maneja el cambio cuando se seleccionan archivos
  const handleFileChange = async (e) => {
    e.preventDefault(); // Evita que el formulario se envíe
    const selectedFiles = e.target.files;
    setNewFiles({ ...newFiles, [field]: Array.from(selectedFiles) });
    //data.setFieldValue(`${field}.files`,Array.from(selectedFiles))
    setFiles([...selectedFiles]);
  };

  // Función para cerrar el modal
  const closeModal = (event) => {
    event.preventDefault();
    setOpenModal(!openModal);
  };

  const handleRemoveFile = async (file) => {
    try {
      const updatedFiles = filesView.filter((f) => f.uniqueName !== file);
      setFilesView(updatedFiles);
      const response = await fuelsFormController.deleteFileApi(
        accessToken,
        file
      );
      //setMessage(response.message);
      removeFile(updatedFiles);
    } catch (error) {
      // setMessage('Error al elimianr el archivo');
    }
  };

  const removeFile = async (updatedFiles) => {
    data.setFieldValue(`${field}.files`, updatedFiles);
  };

  return (
    <>
      {/* Input para seleccionar los archivos */}
      {/* <Input
        type="file"
        multiple
        icon={"paperclip"}
        onChange={handleFileUpload}
      /> */}

      <Popup
        content={t("upload_file")}
        trigger={
          <Button
            default
            onClick={handleButtonClick}
            icon="paperclip"
            color={files.length > 0 ? "green" : "grey"}
          ></Button>
        }
      />
      {/* Mensajes de éxito o error */}
      {successMessage && (
        <Message success>
          <Message.Header>Éxito</Message.Header>
          <p>{successMessage}</p>
        </Message>
      )}

      {errorMessage && (
        <Message error>
          <Message.Header>Error</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}

      <Popup
        content={t("view_file")}
        trigger={
          <Button
            primary
            onClick={closeModal}
            icon="eye"
          ></Button>
        }
      />
      {/* Modal para mostrar los archivos subidos */}
      <BasicModal show={openModal} close={closeModal} title="Archivos subidos" size="tiny">
          <List divided>
            {filesView.length > 0 && (
              <>
                <Header as="h4">Archivos existentes</Header>
                {filesView.map((filePath, index) => (
                  <List.Item key={index}>
                    {/* <a href={`/${filePath.url}`} target="_blank" rel="noopener noreferrer">
                        {filePath.url}
                      </a> */}

                    <FileViewer
                      fileName={filePath.name}
                      fileUniqueName={filePath.uniqueName}
                      handleRemove={handleRemoveFile}
                      t={t}
                    />
                  </List.Item>
                ))}
              </>
            )}
            {newFiles[field] && newFiles[field].length > 0 && (
              <>
                <Header as="h4">Archivos nuevos (se guardarán al enviar)</Header>
                {newFiles[field].map((file, index) => (
                  <List.Item key={`new-${index}`}>
                    <List.Content floated="left">{file.name}</List.Content>
                    <List.Content floated="right">
                      <Button
                        color="blue"
                        onClick={() => window.open(URL.createObjectURL(file), '_blank')}
                        icon="eye"
                      />
                      <Button
                        color="red"
                        onClick={() => {
                          const updatedNewFiles = newFiles[field].filter((_, i) => i !== index);
                          setNewFiles({ ...newFiles, [field]: updatedNewFiles });
                        }}
                        icon="trash alternate"
                      />
                    </List.Content>
                  </List.Item>
                ))}
              </>
            )}
            {filesView.length === 0 && (!newFiles[field] || newFiles[field].length === 0) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5em",
                  color: "#9e9e9e",
                  padding: "2em 0",
                }}
              >
                <Icon name="file outline" size="big" />
                <span>No se encontraron archivos subidos.</span>
              </div>
            )}
          </List>
          <div className="view-files-actions" style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5em' }}>
            <Button secondary size="small" style={{ minWidth: 100 }} onClick={closeModal}>{t("close")}</Button>
          </div>
      </BasicModal>
    </>
  );
}
